export default function (self, transactions) {
  let params = { company: [], production: [], bank: [] }
  let transIds = {}
  transactions.forEach(trx => {
    let { id, batch } = trx
    if (trx.bank && trx.company && trx.production) {
      params.company.push(trx.company)
      params.production.push(trx.production)
      params.bank.push(trx.bank)
    } else if (trx.bank && !trx.company && trx.production) {
      const defaultCompany = self.$store.getters.getDefaultCompany ? self.$store.getters.getDefaultCompany.id : 1
      params.company.push(defaultCompany)
      params.production.push(trx.production)
      params.bank.push(trx.bank)
    } else if (batch && typeof batch === 'number') {
      batch = self.$store.getters.getBatchById(batch)
      if (typeof batch === 'object' && batch.hasOwnProperty('bank')) {
        params.company.push(batch.company)
        params.production.push(batch.production)
        params.bank.push(batch.bank)
      } else {
        if (trx.batch_data) {
          batch = trx.batch_data
          params.company.push(batch.company)
          params.production.push(batch.production)
          params.bank.push(batch.bank)
        }
      }
    } else if (batch && typeof batch === 'object' && batch.company && batch.production && batch.bank) {
      params.company.push(batch.company)
      params.production.push(batch.production)
      params.bank.push(batch.bank)
    } else {
      batch = self.$store.getters.getDefaultBatch
      params.company.push(batch.company)
      params.production.push(batch.production)
      params.bank.push(batch.bank)
    }
    let formattedType = ''
    switch (trx.transactionType) {
      case 'Journal Entry':
        formattedType = 'journalentry'
        break
      case 'Accounts Payable':
        formattedType = 'accountspayable'
        break
      case 'Purchase Orders':
        formattedType = 'purchaseorder'
        break
      case 'Petty Cash':
        formattedType = 'pettycash'
        break
      case 'Accounts Receivable':
        formattedType = 'accountsreceivable'
        break
      default:
        formattedType = trx.transactionType
        break
    }

    Array.isArray(transIds[formattedType]) ? transIds[formattedType].push(id) : transIds[formattedType] = [id]
  })
  if (Object.keys(transIds).length) {
    Object.assign(params, transIds)
    return params
  }
  return null
}
